import React from 'react';

/**
 * FormField — componente definito a livello di modulo (non dentro altri componenti).
 * Evita il problema di focus loss causato da componenti ridefiniti ad ogni render.
 */
export function FormField({ label, name, type = 'text', placeholder = '', rows, form, setForm, options, testId }) {
  const value = form?.[name] ?? '';
  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [name]: type === 'number' ? (parseFloat(e.target.value) || 0) : e.target.value,
    }));
  };

  return (
    <div>
      <label className="label-muted block mb-1">{label}</label>
      {rows ? (
        <textarea
          className="input-dark resize-none"
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          data-testid={testId}
        />
      ) : options ? (
        <select className="input-dark" value={value} onChange={handleChange} data-testid={testId}>
          {options.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      ) : (
        <input
          className="input-dark"
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          data-testid={testId}
        />
      )}
    </div>
  );
}
